<template>
  <div class="offer-main">
    <!-- <p>{{getOfferTotal}}</p>
    <button class="go-btn" @click="enterInterview">进入面试</button> -->
    <div class="img-box">
      <img class="title" src="http://wwj.jijiagames.com//web/act/20190410/Title_5.png" alt="">
      <img class="yuanbao posa" src="../assets/img/yuanbao_homepage.png" alt="">
      <img class="hr posa" src="../assets/img/HR_homepage.png" alt="">
      <img class="engineer posa" src="../assets/img/engineer_homepage.png" alt="">
      <img class="minister posa" src="../assets/img/prime minister_homepage.png" alt="">
      <img class="sales posa" src="../assets/img/sales_homepage.png" alt="">
      <div class="loading-box posa">
          <img  class="loading-img" src="http://wwj.jijiagames.com//web/act/20190410/loading.png" alt="">
          <span>{{progress}}%</span>
      </div>
    </div>
  </div>
</template>
<script>
import http from 'axios';

const url = 'http://wwj.jijiagames.com//web/act/20190410/';
export default {
    data() {
        return {
            num: 113,
            timer: '',
            aa: '',
            progress: 5,
            loadingList: [
                'BG_endpage.png',
                'bg_homepage.jpg',
                'BG_question.jpg',
                'brush_homepage.png',
                'engineer_homepage.png',
                'engineer_question.png',
                'engineer_share.jpg',
                'HR_end.jpg',
                'HR_homepage.png',
                'HR_question.png',
                'HR_share.jpg',
                'loading.gif',
                'loading2.png',
                'music_off.png',
                'music_on.png',
                'painter_end.jpg',
                'painter_end.png',
                'painter_question.png',
                'painter_share.jpg',
                'pencil.png',
                'poet_end.jpg',
                'poet_share.jpg',
                'prime minister_end.jpg',
                'prime minister_homepage.png',
                'prime minister_question.png',
                'prime minister_share.jpg',
                'sales_end.jpg',
                'sales_homepage.png'
            ]
        };
    },
    mounted() {
        const promiseList = [
            `${url}BG_endpage.png`,
            `${url}bg_homepage.jpg`,
            `${url}BG_question.jpg`,
            `${url}civilian_end.png`,
            `${url}engineer_end.png`,
            `${url}HR_end.png`,
            `${url}loading.png`,
            `${url}loading2.png`,
            `${url}painter_end.png`,
            `${url}poet_end.png`,
            `${url}prime minister_end.png`,
            `${url}sales_end.png`,
            `${url}share_bg.png`,
            `${url}Title_1.png`,
            `${url}Title_5.png`,
            '../assets/img/zhen_question.png',
            '../assets/img/yuanbao_share.png',
            '../assets/img/shou_question.png',
            '../assets/img/shou_question.png',
            '../assets/img/music_off.png',
            '../assets/img/music_on.png',
            '../assets/img/civilian_share.jpg',
            '../assets/img/engineer_share.jpg',
            '../assets/img/HR_share.jpg',
            '../assets/img/painter_share.jpg',
            '../assets/img/poet_share.jpg',
            '../assets/img/prime minister_share.jpg',
            '../assets/img/sales_share.jpg',
            '../assets/img/sales_share.jpg'
        ].map(v => this.loadImg(v));
        Promise.all([
            ...promiseList,
            http.get('/font/shuti.ttf')
        ]).then(() => {
            this.changeProgress();
        }).catch(() => {
            this.speed = 70;
        });
    },
    methods: {
        enterInterview() {
            this.$emit('next', 2);
        },
        loadImg(url) {
            return new Promise(res => {
                const img = new Image();
                img.src = url;
                img.onload = () => {
                    res();
                };
                img.onerror = () => {
                    res();
                };
            });
        },
        // 进度
        changeProgress() {
            this.timer = setInterval(() => {
                this.progress += 1;
                if (this.progress >= Math.floor((Math.random() * 20) + 50)) {
                    clearInterval(this.timer);
                    setTimeout(() => {
                        this.timer = setInterval(() => {
                            this.progress += 1;
                            if (this.progress >= 100) {
                                this.progress = 100;
                                clearInterval(this.timer);
                                this.$emit('next', 2);
                            }
                        }, 10);
                    }, 800);
                }
            }, 15);
        }
    }
};
</script>

<style lang="stylus" scoped>
.offer-main
    width 100%
    height 100%
    background url("http://wwj.jijiagames.com//web/act/20190410/bg_homepage.jpg") 0 0/100% 100% no-repeat
.img-box
    width 100%
    height 100%
    position relative
    padding-top:2.46rem
    text-align center
.posa
    position absolute
.hr
    top 4.53rem
    left 0
    animation up 1.2s ease-out infinite
.yuanbao
    top 1.62rem
    left 0.15rem
.engineer
    top 4.74rem
    right 0
    animation down 1.2s ease-out infinite
.minister
    bottom 0
    right 0
    animation down 1.2s ease-out infinite
.sales
    left 0
    bottom 0
    animation down 1.2s ease-out infinite
.loading-box
    top 6rem
    left 50%
    transform translateX(-50%)
    & span
        color:#f66
    .loading-img
        animation: loadingAnimation 1s infinite Linear;

    span
        position absolute
        top 1rem
        left 0.88rem
        font-size 0.4rem
        color #7b2e0e
@keyframes up
    0%{
        transform translateY(0)
    }
    30%{
        transform translateY(5px)
    }
    50%{
        transform translateY(0px)
    }
    80%{
        transform translateY(-5px)
    }
    100%{
        transform translateY(0)
    }
@keyframes down
    0%{
        transform translateY(0)
    }
    30%{
        transform translateY(-5px)
    }
    50%{
        transform translateY(-6px)
    }
    100%{
        transform translateY(0px)
    }

@keyframes loadingAnimation
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }

</style>
